<h2 mat-dialog-title>Selecionar período</h2>

<mat-dialog-content>
  <mat-form-field appearance="fill" class="w-full">
    <mat-label>Período</mat-label>

    <mat-date-range-input [rangePicker]="picker" [min]="data.minDate" [max]="dynamicMaxDate">
      <input matStartDate placeholder="Data Inicial" [(ngModel)]="inicio" (ngModelChange)="onStartDateChange($event)" readonly>
      <input matEndDate placeholder="Data Final" [(ngModel)]="fim" readonly>
    </mat-date-range-input>

    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-date-range-picker #picker></mat-date-range-picker>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancelar()">Cancelar</button>
  <button mat-raised-button color="primary" [disabled]="!inicio || !fim" (click)="confirmar()">
    Confirmar
  </button>
</mat-dialog-actions>